import React from 'react';
import { useHistory } from 'react-router-dom';
import chesssLogo from '../../images/chessslogo.png';
import mansalva from '../../images/Mansalva/Mansalva-Regular.ttf';
import { isNativeApp } from '../../util/platformDetection';

const AboutMobile = () => {
  const history = useHistory();

  return (
    <div style={{
      width: '100vw',
      height: 'calc(100dvh - 55px)', // Account for bottom navigation
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: 'env(safe-area-inset-top)' // Header only in native app
    }}>
      <style>
        {`
          @font-face {
            font-family: 'Mansalva';
            src: url(${mansalva}) format('truetype');
            font-weight: normal;
            font-style: normal;
          }
        `}
      </style>
      {/* Header */}
      <div style={{
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
        padding: '15px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <h2 style={{
          color: 'gold',
          margin: 0,
          fontSize: '24px',
          fontWeight: 'bold'
        }}>
          About
        </h2>
        <button
          onClick={() => history.goBack()}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#888',
            fontSize: '28px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          ✕
        </button>
      </div>

      {/* Content */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '20px',
        paddingBottom: 'env(safe-area-inset-bottom)' // iPhone gesture area
      }}>
        {/* Logo Section */}
        <div style={{
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          <img
            src={chesssLogo}
            alt="Chess Social"
            style={{
              width: '100px',
              height: '100px',
              marginBottom: '10px'
            }}
          />
          <h1 style={{
            fontFamily: 'Mansalva, cursive',
            color: 'gold',
            fontSize: '32px',
            fontWeight: 'normal',
            margin: 0
          }}>
            ChessThread
          </h1>
        </div>

        {/* Mission Section */}
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '8px',
          padding: '25px',
          border: '1px solid #333',
          marginBottom: '20px'
        }}>
          <h3 style={{
            color: 'gold',
            fontSize: '20px',
            fontWeight: 'bold',
            marginBottom: '15px'
          }}>
            Our Mission
          </h3>
          <p style={{
            color: 'white',
            fontSize: '18px',
            fontStyle: 'italic',
            margin: '20px 0',
            textAlign: 'left'
          }}>
            Make sharing chess effortless.
          </p>
          <p style={{
            color: '#ccc',
            fontSize: '16px',
            lineHeight: '1.6',
            margin: 0
          }}>
            Whether you're creating puzzles from your own games, testing variations on others', or kicking back to watch the magic unfold within the community, we've built the easiest way for you to share and enjoy chess online.
          </p>
        </div>

        {/* Tagline Section */}
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '8px',
          padding: '25px',
          border: '1px solid gold',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          <p style={{
            color: 'gold',
            fontSize: '18px',
            fontStyle: 'italic',
            fontWeight: 'bold',
            margin: 0
          }}>
            If it can live on a chessboard, it belongs here.
          </p>
        </div>



        {/* Footer Links */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-around',
          padding: '20px 0',
          borderTop: '1px solid #333',
          marginTop: '30px'
        }}>
          <button
            onClick={() => history.push('/mobile/terms')}
            style={{
              background: 'none',
              border: 'none',
              color: '#888',
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.target.style.color = '#ccc'}
            onMouseOut={(e) => e.target.style.color = '#888'}
          >
            Terms & Conditions
          </button>
          <button
            onClick={() => history.push('/mobile/privacy')}
            style={{
              background: 'none',
              border: 'none',
              color: '#888',
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.target.style.color = '#ccc'}
            onMouseOut={(e) => e.target.style.color = '#888'}
          >
            Privacy Policy
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutMobile;